export const FETCH_CURRENT_USER = "FETCH_CURRENT_USER";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
export const CACHE_TAG = "CACHE_TAG"
export const NOTIFICATION_HIDE = "NOTIFICATION_HIDE"
